import React from 'react';
import './Footer.css';
import { CONFIG } from '../data';

function Footer() {
  const go = id =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="container footer-inner">

        <div className="f-brand">
          <img src="/logo.png" alt="Logo" className="f-logo" />
          <div>
            <strong>{CONFIG.businessName}</strong>
            <p>{CONFIG.tagline}</p>
          </div>
        </div>

        <div className="f-nav">
          {['about','menu','services','gallery','contact'].map(s => (
            <button key={s} onClick={() => go(s)}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>

        <p className="f-copy">
          © {new Date().getFullYear()} {CONFIG.businessName}. Crafted with ❤️ in Tamil Nadu.
        </p>

      </div>
    </footer>
  );
}

export default Footer;